import { PaymentSelectionProvider } from '@context/Payment/PaymentSelection';
import PaymentSelectionView from './PaymentSelectionView';

const PaymentSelection = () => {
  return (
    <PaymentSelectionProvider>
      <PaymentSelectionView />
    </PaymentSelectionProvider>
  );
};

export default PaymentSelection;
